import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { reservationsApi } from '../lib/api';

// Prices come from the existing booking calculator, never a duplicated tariff table.
export const ParkingPriceExamples = () => {
  const [quotes, setQuotes] = useState(null);
  useEffect(() => {
    let active = true;
    const start = new Date();
    start.setDate(start.getDate() + 14);
    start.setHours(10, 0, 0, 0);
    Promise.all([3, 7, 14].map(async days => {
      const end = new Date(start);
      end.setDate(end.getDate() + days);
      const { data } = await reservationsApi.calculatePrice(start.toISOString(), end.toISOString());
      const amount = data.total_cents != null ? data.total_cents / 100 : data.total_euros;
      if (!data.valid || !Number.isFinite(amount) || amount < 0) throw new Error('Quote unavailable');
      return { days, amount, start, end };
    })).then(data => { if (active) setQuotes(data); })
      .catch(() => { if (active) setQuotes([]); });
    return () => { active = false; };
  }, []);
  const date = value => value.toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' });
  return (
    <section className="parking-content-section" aria-labelledby="parking-prices-title" data-testid="parking-price-examples">
      <h2 id="parking-prices-title" data-testid="parking-prices-title">Ejemplos de precio total</h2>
      {quotes === null && <p role="status" data-testid="parking-prices-loading">Consultando tarifas actualizadas…</p>}
      {quotes?.length === 0 && <p role="status" data-testid="parking-prices-error">No hemos podido consultar las tarifas ahora.{' '}
        <Link to="/reservar" data-testid="parking-prices-fallback-link">Comprueba el precio para tus fechas en el formulario de reserva.</Link>
      </p>}
      {!!quotes?.length && <>
        <div className="parking-table-wrap"><table data-testid="parking-prices-table">
          <caption>Ejemplos para coche, sin extras ni descuentos. Entrada y salida a las 10:00.</caption>
          <thead><tr><th scope="col">Estancia</th><th scope="col">Fechas de ejemplo</th><th scope="col">Total calculado</th></tr></thead>
          <tbody>{quotes.map(quote => <tr key={quote.days}>
            <th scope="row" data-testid={`parking-price-duration-${quote.days}`}>{quote.days} días de estancia</th>
            <td data-testid={`parking-price-dates-${quote.days}`}>{date(quote.start)} – {date(quote.end)}</td>
            <td data-testid={`parking-price-total-${quote.days}`}>{quote.amount.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })}</td>
          </tr>)}</tbody>
        </table></div>
        <p data-testid="parking-prices-disclaimer">Estos importes corresponden solo a las fechas mostradas. Consulta los días facturados y el desglose de tu reserva; el precio puede cambiar con las fechas, horas, vehículo y extras.</p>
      </>}
      <Link to="/reservar" className="parking-reserve" data-testid="parking-prices-reserve">Consultar mis fechas <ArrowRight size={18} aria-hidden="true" /></Link>
    </section>
  );
};